import { render, staticRenderFns } from "./SelectTypeDialog.vue?vue&type=template&id=6dd63fa5&scoped=true&"
import script from "./SelectTypeDialog.vue?vue&type=script&lang=js&"
export * from "./SelectTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd63fa5",
  null
  
)

export default component.exports